const WebAppsConstants = {
  GET_SUCCESS: 'SR_WEBAPPS_GET_SUCCESS',
  GET_FAIL: 'SR_WEBAPPS_GET_FAIL',

  SHOW: 'SR_WEBAPPS_SHOW',
  HIDE: 'SR_WEBAPPS_HIDE'
};

export default WebAppsConstants;
